import axios from 'axios';
import { makeApiUrl } from '../../../../../../Util/S/Function/util.js';

const postUpdateLike = async (already_like, stores_product_id) => {
  const {
    data: { ok },
  } = await axios.post(
    makeApiUrl('/:lang/@api/stores_products_like', {
      lang: ET.lang,
    }),
    {
      already_like,
      stores_product_id,
    },
  );
  return ok;
};

export const updateLikeApiHelper = {
  post: postUpdateLike,
};
